<div *ngIf="is_no_data">
  <div class="col-12 mb-3 p-1" >
      <div class="card">
          <div class="card-body">
              <a class="t" style="font-size: medium;color: black;">{{'COMMON.MESSAGES.SPORT-NO-EVENT' | translate}}</a>
          </div>
      </div>
  </div>
</div>

<app-sport-details *ngIf="viewSelectionBlock == true" [selectedMeeting]="selectedMeeting"></app-sport-details>

<div class="container mt-2 pb-4" [hidden]="viewSelectionBlock">
  <div class="row" id="accordionExample">
    <div  class="betting-category card-collapsible mb-2 px-0" id="dropdown" (click)="colorChange($event,i)" *ngFor="let odd of ODDs; let i=index">
      <div class="card-header px-2" [class.has-live-video]="odd.hasLiveVideo" id="scrollto{{i}}">
        <div (click)="getOddData(odd.id)" class="p-2 dropdown-toggle-chevron collapsed addpadding" data-toggle="collapse" [attr.data-target]="'#id' + i" aria-expanded="true" aria-controls="collapseOne">
          <div class="d-flex flex-column" style="gap: 7px;">
            <div style="padding-top: 0.3rem;" *ngIf="selectedBetCategory?.sportCode != 'FM' && selectedBetCategory?.sportCode != 'GF'">
              <span *ngIf="odd.tourName" style="display:block" class="t-faded t-smaller text-truncate-tourName">{{ odd.tourName }}</span>
              <span class="t-smaller m-time">{{odd.meetingLocalTime}}</span>
            </div>
            <span *ngIf="selectedBetCategory?.sportCode != 'FM' && selectedBetCategory?.sportCode != 'GF'" class="t match-title">
              {{odd?.sel1Name?.substring(0,19) || ''}}
              <ng-container *ngIf="odd?.sel1Name?.length > 19">..</ng-container>

              <span>{{odd.matchType}}</span> {{ odd?.sel2Name?.substring(0, 19) || '' }}
              <ng-container *ngIf="odd?.sel2Name?.length > 19">..</ng-container>
            </span>  
            <!-- SHOW ONLY IN FOMULA AND GOLF -->
            <span *ngIf="selectedBetCategory.sportCode == 'FM' || selectedBetCategory.sportCode == 'GF'" class="t text-truncate match-title">{{odd.meetingName}}</span>   
            <span *ngIf="selectedBetCategory.sportCode == 'FM' || selectedBetCategory.sportCode == 'GF'" class="t-smaller">{{odd.meetingLocalTime}}</span>

            <span *ngIf="odd?.meetingMetaData?.progressScore != '-/-'" class="t-faded t-smaller">{{odd?.meetingMetaData?.progressScore}}</span>
            <span *ngIf="odd?.meetingMetaData?.progressScore2 != '-/-'" class="t-faded t-smaller">{{odd?.meetingMetaData?.progressScore2}}</span>
          </div>
        </div>
        <button *ngIf="odd.hasLiveVideo" type="button" class="live-video-button" aria-label="Match information"
          (click)="onLiveVideoClick(odd, $event)">
          <img 
            class="live-icon-image"
            src="assets/images/live-video.png" 
            alt="" 
            width="48" 
            height="28"
            [class.video-eligible]="getVideoEligibilityState(odd.meetingId) === true"
            [class.video-ineligible]="getVideoEligibilityState(odd.meetingId) === false"
          >
        </button>
        <div class="p-2 d-flex align-items-center" *ngIf="odd.matchWinner.length!=0 && selectedBetCategory.showMatchWinner==1">
          <div class="t flex-fill text-black">{{matchWinner}}</div>

          <button *ngIf="(odd.matchWinner[0] && odd.matchWinner[0].lastOddDec!=1) && odd.matchWinner[0].Status =='G'" (click)="setSPOdd(odd.matchWinner[0])"
            [ngClass]="{'btn-tertiaryActive':odd.matchWinner[0].clicked == true, 'odds':odd.matchWinner[0].clicked != true}"
            class="btn btn-tertiary flex-fill ml-2 odds">
            <span class="secondary">1 <br>{{odd.matchWinner[0].lastOddDec}}</span>
          </button>
          <button *ngIf="(odd.matchWinner[0] && odd.matchWinner[0].lastOddDec==1) || odd.matchWinner[0].Status =='S'"  [ngClass]="{'btn-tertiaryActive':odd.matchWinner[0].clicked == true, 'odds':odd.matchWinner[0].clicked != true}" class="btn btn-tertiary-red flex-fill ml-2 odds">
            <span class="secondary suspend">1<br>{{'COMMON.SUSPEND' | translate}}</span>
          </button>

          <button *ngIf="allData[i].sel3Id && odd.matchWinner[2].lastOddDec!=1" (click)="setSPOdd(odd.matchWinner[2])"
            [ngClass]="{'btn-tertiaryActive':odd.matchWinner[2].clicked == true, 'odds':odd.matchWinner[2].clicked != true}"
            class="btn btn-tertiary flex-fill ml-2 odds">
            <span class="secondary" >X <br>{{odd.matchWinner[2].lastOddDec}}</span>
          </button>
          <button *ngIf="allData[i].sel3Id && odd.matchWinner[2].lastOddDec==1"  [ngClass]="{'btn-tertiaryActive':odd.matchWinner[2].clicked == true, 'odds':odd.matchWinner[2].clicked != true}" class="btn btn-tertiary-red flex-fill ml-2 odds">
            <span class="secondary suspend" >X <br>{{'COMMON.SUSPEND' | translate}}</span>
          </button>

          <button *ngIf="(odd.matchWinner[1] && odd.matchWinner[1].lastOddDec!=1) && odd.matchWinner[1].Status =='G'" (click)="setSPOdd(odd.matchWinner[1])"
            [ngClass]="{'btn-tertiaryActive':odd.matchWinner[1].clicked == true, 'odds':odd.matchWinner[1].clicked != true}"
            class="btn btn-tertiary flex-fill ml-2 odds">
            <span class="secondary" >2 <br>{{odd.matchWinner[1].lastOddDec}}</span>
          </button>
          <button *ngIf="(odd.matchWinner[1] && odd.matchWinner[1].lastOddDec==1) || odd.matchWinner[1].Status =='S'"  [ngClass]="{'btn-tertiaryActive':odd.matchWinner[1].clicked == true, 'odds':odd.matchWinner[1].clicked != true}" class="btn btn-tertiary-red flex-fill ml-2 odds">
            <span class="secondary suspend" >2 <br>{{'COMMON.SUSPEND' | translate}}</span>
          </button>

        </div>
      </div>
      <div class="collapse" id="id{{i}}" data-parent="#accordionExample">
        <div *ngIf="isOddShown(odd.id)">
        <table class="table table-striped mb-0 border-top">
          <tbody>
            <tr *ngFor="let oddEvents of odd.eventData; index as i" class="sub-item">
              <td>
                <div class="d-flex flex-column">
                  <span class="t">{{oddEvents.eventName}}</span>
                  <span class="t-faded t-smaller">{{oddEvents.eventLabel}}</span>
                </div>
              </td>
              <td class="text-right">
                <a (click)="viewSportDetails(oddEvents,$event)" class="btn btn-tertiary icon">
                  <span class="icon icon-arrow-right"></span>
                </a>
              </td>
            </tr>   
          </tbody>
        </table>
      </div>
    </div>
    </div>
  </div>
</div>
